import React from 'react'
import {Modal, Row} from 'antd'
import ClientBudgetForm from '../../../../components/Project/Resources/ClientBudgets/ClientBudgetForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function ClientBudgetModal(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    remove,
    removing,
  } = props
  return (
    <Modal
      visible={visible}
      title={'ClientBudget'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Client Budget Line'}
          isNew={modalType === 'new'}
          isEdit={modalType === 'edit'}
        />
      }
      width={'75%'}>
      <Row>
        <ClientBudgetForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

ClientBudgetModal.propTypes = {}
ClientBudgetModal.defaultProps = {}

export default ClientBudgetModal
